var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#191E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2507 11.4166C12.2507 9.34556 13.9296 7.66663 16.0007 7.66663C18.0717 7.66663 19.7507 9.34556 19.7507 11.4166C19.7507 13.4877 18.0717 15.1666 16.0007 15.1666C13.9296 15.1666 12.2507 13.4877 12.2507 11.4166ZM11.209 21.625C11.209 18.9786 13.3543 16.8333 16.0007 16.8333C18.647 16.8333 20.7923 18.9786 20.7923 21.625V23.7083C20.7923 24.0535 20.5125 24.3333 20.1673 24.3333H11.834C11.4888 24.3333 11.209 24.0535 11.209 23.7083V21.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bb665c7bafae9d2c62bb1b8944c17791.svg";
export { ForwardRef as ReactComponent };